import type { ArchiveSession } from './types';

const ARCHIVE_SESSION_KEY = 'archive_session_cache';

export function getArchiveSession(): ArchiveSession | null {
  try {
    const raw = localStorage.getItem(ARCHIVE_SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw) as ArchiveSession;
    if (!session.userId || !session.nickname || !session.role) return null;
    return {
      ...session,
      sectionId: session.sectionId ?? null,
      sectionName: session.sectionName ?? null,
      sectionIds: session.sectionIds ?? (session.sectionId ? [session.sectionId] : []),
      sectionNames: session.sectionNames ?? (session.sectionName ? [session.sectionName] : []),
    };
  } catch {
    return null;
  }
}

export function setArchiveSession(session: ArchiveSession): void {
  localStorage.setItem(ARCHIVE_SESSION_KEY, JSON.stringify(session));
}

export function clearArchiveSession(): void {
  localStorage.removeItem(ARCHIVE_SESSION_KEY);
}
